enum CalendarType {
  DAY = 1,
  MONTH = 2,
  YEAR = 3,
}
export default CalendarType;
